/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";
import helper from './utils/helper';

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        clientId: "9d3db354-fd99-447e-8cae-a2bc7e540dd6", // This is the ONLY mandatory field that you need to supply.
        authority: "https://login.microsoftonline.com/61ccc9e5-5ff3-4ba4-a610-008848962512", // Defaults to "https://login.microsoftonline.com/common"
        redirectUri: helper.getAzureRedirectURL(), // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
        postLogoutRedirectUri: "/dashboard", // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            }
        }
    }
};

let state = "";
if (process.env.REACT_APP_ENV !== 'DEV') {
    let orderId = localStorage.getItem('orderId');

    if (!orderId) {
        orderId = helper.getOrderIdFromQueryString('orderId');
    }
    state = `${helper.getAzureRedirectURL()}/dashboard?orderId=${orderId}`;
    console.log("authConfig.js->state: ", state);
}
/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    // scopes: [],
    scopes: ["user.read"],
    state: state,
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
    graphMe: {
        endpoint: "https://graph.microsoft.com/v1.0/me",
        scopes: [
            "User.Read",
            "profile",
            "offline_access",
            "https://graph.microsoft.com/mail.read"
        ],
    },
    apiOrders: {
        endpoint: "http://localhost:3002/api/cs/orders",
        scopes: ["api://9d3db354-fd99-447e-8cae-a2bc7e540dd6/access_as_user"], // e.g. api://xxxxxx/access_as_user
    },
    state: state,
}
